import { createContext, FC, useContext, useState } from 'react';
import * as creditService from 'api/credit';
import { ICredit, ICreditContext, ICreditProviderProps } from './types';

const CreditContext = createContext<ICreditContext | null>(null);

const CreditProvider: FC<ICreditProviderProps> = props => {
  const [loading, setLoading] = useState<boolean>(false);
  const [results, setResults] = useState<ICredit[]>([]);

  const fetchCreditsDetails = async (id: string) => {
    try {
      setLoading(true);
      const response = await creditService.fetchCreditsDetails(id);
      if (response.data) {
        setResults(response.data);
      }

      setLoading(false);
    } catch (error) {
      setLoading(false);
      setResults([]);
    }
  };

  return (
    <CreditContext.Provider
      value={{
        loading,
        results,
        fetchCreditsDetails,
      }}
      {...props}
    />
  );
};

const useCredit = () => {
  const hookData = useContext(CreditContext);
  if (!hookData) throw new Error('Hook used without provider');
  return hookData;
};

export { CreditProvider, useCredit };
